import { render } from "./KnowhowTip1.vue?vue&type=template&id=6eaae94e"
import script from "./KnowhowTip1.vue?vue&type=script&lang=js"
export * from "./KnowhowTip1.vue?vue&type=script&lang=js"

import "./KnowhowTip1.vue?vue&type=style&index=0&id=6eaae94e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__